import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSnackbar,{attrs:{"timeout:5000":"","value":_vm.hasMessage},on:{"input":_vm.closeSnackbar}},[_c('div',{staticClass:"d-flex justify-space-between align-center"},[_vm._v(" "+_vm._s(_vm.messageText)+" "),_c(VBtn,{attrs:{"color":"white","text":""},on:{"click":_vm.closeSnackbar}},[_vm._v(" "+_vm._s(_vm.$t('components.snackbar.close'))+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }